var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-10-01
 * @brief EHP Check Sheet 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { langState } from '../../../../recoil/langState';
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
//component
import EhpPagination from "../../../common/pagination/EhpPagination";
/**
 * @brief EHP Check Sheet - List 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function SpgCheckList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //
    //const pageInfo = props.pageInfo;
    //const setParentPageInfo = props.setPageInfo;
    const versionList = props.versionList;
    const spgVersion = props.spgVersion;
    const setParentSpgVersion = props.setSpgVersion;
    //화면 이동
    const navigate = useNavigate();
    //
    const stepList = [
        { "stepName": "전체", "stepVal": "" },
        { "stepName": "Basic", "stepVal": "BASIC" },
        { "stepName": "Premium", "stepVal": "PREMIUM" },
        { "stepName": "Advanced", "stepVal": "ADVANCED" },
    ];
    const [selStep, setSelStep] = useState(stepList[0]);
    useEffect(() => {
        setSelStep(stepList[0]);
        setPageInfo(defaultPageInfo);
    }, [selTree]);
    //clog("IN CHECK LIST : INIT : " + JSON.stringify(versionList) + " : version : " + spgVersion);
    //const [versionList, setVersionList] = useState(null);
    const [versionReload, setVersionReload] = useState(false);
    const [checkList, setCheckList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10, "listReload": false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    // option 선택 시  값 변경 액션
    function selectOptionVersion(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        setParentSpgVersion(JSON.parse(optionData));
        // params init
        if (spgVersion.versionNo !== JSON.parse(optionData).versionNo)
            setPageInfo(defaultPageInfo);
    }
    function selectOptionStep(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        setSelStep(JSON.parse(optionData));
        // params init
        if (selStep.stepVal !== JSON.parse(optionData).stepVal)
            setPageInfo(defaultPageInfo);
    }
    function onClickSpgVersionChange(e, sver) {
        var isChange = false;
        versionList.filter(sv => sv.enabled).map((sv, idx) => {
            if ((idx === 0) && (sv.versionNo !== sver.versionNo))
                isChange = true;
        });
        if (isChange === false) {
            return;
        }
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-version-ok");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "267");
        setParentPopWin("pop-version-ok", React.createElement(PopupChangeSpgVersion, { htmlHeader: React.createElement("h1", null, "\uBC84\uC804 \uC801\uC6A9"), versionList: versionList, versionInfo: sver, setSpgVersion: props.setSpgVersion, setVersionReload: setVersionReload, selTree: selTree, setSelTree: props.setSelTree, adminType: props.adminType }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickSpgVersionAdd(e) {
        var isOk = confirm(`Check Sheet 버전을 수정하거나 신규 버전을 추가하시겠습니까?`);
        if (!isOk)
            return;
        setParentWorkMode("NLIST");
    }
    clog("IN SPG CHECK LIST TEMP : INIT : " + JSON.stringify(spgVersion) + "" + JSON.stringify(versionList));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, selTree.spg.spgName)),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "left" },
                    React.createElement("div", { className: "searcharea" },
                        React.createElement("div", { className: "searchinput" },
                            React.createElement("span", { className: "mr-16" },
                                React.createElement("strong", null, "\uC810\uAC80\uB2E8\uACC4")),
                            React.createElement("div", { className: "select w186", onClick: (e) => CUTIL.onClickSelect(e, selectOptionStep) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, selStep.stepName),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, stepList.map((step, idx) => (React.createElement("li", { key: `st_${idx.toString()}`, className: "option", "data-value": JSON.stringify(step) }, step.stepName))))),
                            React.createElement("span", { className: "mr-16 ml-24" },
                                React.createElement("strong", null, "\uBC84\uC804")),
                            (!spgVersion) && React.createElement("div", { className: "select w80", onClick: (e) => CUTIL.onClickSelect(e, selectOptionVersion) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, "x1.0"),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null,
                                    React.createElement("li", { key: `ver_x`, className: "option", "data-value": "1.0" }, "1.0"))),
                            (spgVersion) && (versionList) &&
                                React.createElement("div", { className: "select w80", onClick: (e) => CUTIL.onClickSelect(e, selectOptionVersion) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { className: "selected-value" }, spgVersion.versionNo),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null, versionList.filter((sver) => sver.completed).map((sver, idx) => (React.createElement("li", { key: `ver_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sver) }, sver.versionNo))))))),
                    React.createElement("button", { type: "button", className: `${(spgVersion && versionList) && versionList.filter(sv => sv.enabled).map(sv => (sv.versionNo !== spgVersion.versionNo) ? "bg-basic" : "bg-gray")} btn-basic w96 ml-16 js-open`, "data-pop": "pop-version-ok", onClick: (e) => onClickSpgVersionChange(e, spgVersion) },
                        React.createElement("span", null, "\uBC84\uC804 \uBCC0\uACBD"))),
                React.createElement("div", { className: "right" },
                    React.createElement("button", { type: "button", className: "bg-gray js-open", "data-pop": "pop-version", onClick: (e) => onClickSpgVersionAdd(e) },
                        React.createElement("span", null, "\uBC84\uC804 \uC218\uC815/\uCD94\uAC00")))),
            (spgVersion) && /*(checkList.length > 0)&&*/
                React.createElement(CheckList, { adminType: props.adminType, selTree: selTree, selStep: selStep, spgVersion: spgVersion, checkList: checkList, setCheckList: setCheckList, pageInfo: pageInfo, setPageInfo: setPageInfo, workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }))));
}
;
export default SpgCheckList;
function CheckList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const selStep = props.selStep;
    const spgVersion = props.spgVersion;
    const checkList = props.checkList;
    const setParentCheckList = props.setCheckList;
    const pageInfo = props.pageInfo;
    const setParentPageInfo = props.setPageInfo;
    //
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const setParentPopWin = props.setPopWin;
    //화면 이동
    const navigate = useNavigate();
    //
    const [clistMode, setClistMode] = useState("LIST");
    function handleCurPage(page) {
        setParentPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function handleListReload(val, page) {
        if (page > -1) {
            setParentPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page, listReload: true }));
        }
        else {
            setParentPageInfo(Object.assign(Object.assign({}, pageInfo), { listReload: true }));
        }
    }
    //////////////////
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    appPath = appPath + `&spgName=${selTree.spg.spgName}`;
    if (spgVersion) {
        appPath = appPath + "&versionNo=" + spgVersion.versionNo;
    }
    if (selStep.stepVal.length > 0) {
        appPath = appPath + "&stepName=" + selStep.stepVal;
    }
    appPath = appPath + `&language=${CUTIL.apiLangSet(langs)}`;
    const [errorList, setErrorList] = useState([]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/checksheet/step/spg/items/admin?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        //watch: selTree + appPath + listReload + spgVersion
        watch: selTree + appPath + spgVersion + pageInfo.listReload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        /*const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
          setRecoilIsLoadingBox(false);
          navigate(ERR_URL);
        }*/
        if (retData) {
            setRecoilIsLoadingBox(false);
            //clog("IN CHECKLIST : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                setParentCheckList(retData.body);
                setParentPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10
                setClistMode("LIST");
            }
        }
    }, [selTree, retData]);
    function onClickViewSpgCheck(e, checkInfo) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-spgcheck-detail");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "797");
        setClistMode("READ");
        setParentPopWin("pop-spgcheck-detail", //pop-spgcheck-detail
        React.createElement(PopupSpgCheckView, { htmlHeader: React.createElement("h1", null, "\uB2E4\uAD6D\uC5B4 \uAD00\uB9AC"), checkInfo: checkInfo, setListReload: handleListReload, clistMode: "READ", setClistMode: setClistMode, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    //clog("IN CHECK LIST COMP : INIT : " + workMode);
    clog("SPG CHECK LIST : INIT : " + clistMode);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tbl-list checksheet-list" },
            React.createElement("table", { summary: "\uC810\uAC80\uB2E8\uACC4,\uCF54\uB4DC,\uADF8\uB8F9,\uC774\uB984,\uC124\uBA85,\uAC00\uC911\uCE58 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C ACB \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                React.createElement("caption", null, "ACB \uB9AC\uC2A4\uD2B8"),
                React.createElement("colgroup", null,
                    React.createElement("col", { style: { "width": "9%" } }),
                    React.createElement("col", { style: { "width": "15%" } }),
                    React.createElement("col", { style: { "width": "13%" } }),
                    React.createElement("col", { style: { "width": "24%" } }),
                    React.createElement("col", { style: { "width": "26%" } }),
                    React.createElement("col", { style: { "width": "10%" } }),
                    React.createElement("col", { style: { "width": "3%" } })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uC810\uAC80\uB2E8\uACC4"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uCF54\uB4DC"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uADF8\uB8F9"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uC124\uBA85"),
                        React.createElement("th", { scope: "col", className: "txt-left" }, "\uAC00\uC911\uCE58"),
                        React.createElement("th", { scope: "col" },
                            React.createElement("span", { className: "hide" }, "\uC0C1\uC138\uBCF4\uAE30")))),
                React.createElement("tbody", null,
                    (!spgVersion) &&
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 7, className: "" },
                                React.createElement("strong", { className: "txt-purple" }, "Version\uC744 \uC120\uD0DD\uD558\uC138\uC694."))),
                    checkList.map((check, idx) => (React.createElement("tr", { key: `sh_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) },
                            React.createElement("strong", { className: "txt-purple" }, check.checkStepDto.name)),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.code),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.checkGroupDto.groupName),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.name),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) }, check.description),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickViewSpgCheck(e, check) },
                            React.createElement("strong", null, check.weight)),
                        React.createElement("td", { className: "js-open", "data-pop": "pop-spgcheck-detail" },
                            React.createElement("button", { type: "button", className: "btn-more", onClick: (e) => onClickViewSpgCheck(e, check) },
                                React.createElement("span", { className: "hide" }, "\uC0C1\uC138\uBCF4\uAE30"))))))))),
        React.createElement(EhpPagination, { componentName: "HTTPMESSAGELIST", pageInfo: pageInfo, handleFunc: handleCurPage })));
}
;
// SPG 체크 항목 조회 
function PopupSpgCheckView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const checkInfo = props.checkInfo;
    const clistMode = props.clistMode;
    const setParentClistMode = props.setClistMode;
    const setParentPopWin = props.setPopWin;
    const setParentListReload = props.setListReload;
    //
    const [spgCheckItem, setSpgCheckItem] = useState(null);
    const [updateCount, setUpdateCount] = useState(0);
    const defaultRefDtoList = [
        { "score": 0, "reference": "" },
        { "score": 1, "reference": "" },
        { "score": 2, "reference": "" },
        { "score": 3, "reference": "" },
        { "score": 4, "reference": "" },
    ];
    clog("SPG CHECK VIEW : INIT : " + clistMode + " : " + updateCount);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/checksheet/step/spg/item?code=${checkInfo.code}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: checkInfo.code + clistMode + updateCount
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            //clog("IN SPGCHECK VIEW : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                retData.body.map((fcheck) => {
                    if (CUTIL.isnull(fcheck.checkItemRefDtoList))
                        fcheck.checkItemRefDtoList = defaultRefDtoList;
                });
                setSelLang(CONST.STR_APILANG_KOR);
                setSpgCheckItem(retData.body);
                setUpdateCount(0);
            }
        }
    }, [retData]);
    function onClickUpdateSpgCheck(e, check) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-spgcheck-edit");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "797");
        CUTIL.jsclose_Popup("pop-spgcheck-detail");
        //setParentPopWin("pop-spgcheck-detail", null);
        setParentPopWin("pop-spgcheck-edit", React.createElement(PopupSpgCheckUpdate, { htmlHeader: React.createElement("h1", null, "\uB2E4\uAD6D\uC5B4 \uAD00\uB9AC"), checkInfo: check, spgCheckItem: spgCheckItem, setListReload: props.setListReload, clistMode: props.clistMode, setClistMode: props.setClistMode, setPopWin: props.setPopWin, updateCount: updateCount + 1, setUpdateCount: setUpdateCount }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickCancel(e) {
        //setParentListReload(true);
        setParentClistMode("LIST");
        CUTIL.jsclose_Popup("pop-spgcheck-detail");
        setParentPopWin("pop-spgcheck-detail", null);
    }
    const [selLang, setSelLang] = useState(CONST.STR_APILANG_KOR);
    const langSet = [
        { "tabId": 0, "tabTxt": "한국어", "tabVal": CONST.STR_APILANG_KOR },
        { "tabId": 1, "tabTxt": "English", "tabVal": CONST.STR_APILANG_ENG },
        { "tabId": 2, "tabTxt": "中文", "tabVal": CONST.STR_APILANG_CHA },
    ];
    useEffect(() => {
        setSelLang(CONST.STR_APILANG_KOR);
    }, []);
    function onClickLangTab(e) {
        var actTag = (e.target.tagName === "LI") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        setSelLang(tabInfo.tabVal);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (React.createElement(React.Fragment, { key: `rfr_${idx.toString()}` },
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC810\uAC80\uB2E8\uACC4"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkStepDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAE30\uAE30 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.spgDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uADF8\uB8F9 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkGroupDto.groupName : "", disabled: true })))),
                React.createElement("ul", { className: "tab__small" }, langSet.map((tlang, idx) => (React.createElement("li", { key: `tli_${idx.toString()}`, className: (tlang.tabVal === selLang) ? "on" : "", onClick: (e) => onClickLangTab(e), "data-value": JSON.stringify(tlang) },
                    React.createElement("a", null, tlang.tabTxt))))),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.checkItemName)) ? checkItem.checkItemName : "" : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC124\uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.description)) ? checkItem.description : "" : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAC00\uC911\uCE58"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.weight)) ? checkItem.weight : "" : "", disabled: true }))))))),
            React.createElement("div", { className: "tbl-list" },
                React.createElement("table", { summary: "\uC810\uC218, \uD3C9\uAC00\uAE30\uC900 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD310\uC815 List \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uD310\uC815 List"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "16%" } }),
                        React.createElement("col", { style: { "width": "84%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }, "\uC810\uC218"),
                            React.createElement("th", { scope: "col" }, "\uD3C9\uAC00\uAE30\uC900"))),
                    React.createElement("tbody", null, (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (checkItem.checkItemRefDtoList.map((citem, idx) => (React.createElement("tr", { key: `tr_${idx.toString()}` },
                        React.createElement("td", null,
                            React.createElement("p", null, citem.score)),
                        React.createElement("td", null,
                            React.createElement("p", { className: "txt-left" }, citem.reference))))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-open btn-close", "data-pop": "pop-spgcheck-edit", onClick: (e) => onClickUpdateSpgCheck(e, checkInfo) },
                React.createElement("span", null, "\uC218\uC815")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
// SPG 체크 항목 조회 
function PopupSpgCheckUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const checkInfo = props.checkInfo;
    const clistMode = props.clistMode;
    const setParentClistMode = props.setClistMode;
    const setParentPopWin = props.setPopWin;
    const setParentListReload = props.setListReload;
    const updateCount = props.updateCount;
    const setParentUpdateCount = props.setUpdateCount;
    //
    const [spgCheckItem, setSpgCheckItem] = useState(null);
    const [errorList, setErrorList] = useState([]);
    //const onClickUpdateCheckMessage = props.onClickUpdateCheckMessage;
    const defaultRefDtoList = [
        { "score": 0, "reference": "" },
        { "score": 1, "reference": "" },
        { "score": 2, "reference": "" },
        { "score": 3, "reference": "" },
        { "score": 4, "reference": "" },
    ];
    clog("SPG CHECK UPDATE : INIT : " + clistMode + " : " + updateCount);
    useEffect(() => {
        setSpgCheckItem(props.spgCheckItem);
    }, [updateCount, props.spgCheckItem]);
    function onClickCancel(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-spgcheck-detail");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "797");
        CUTIL.jsclose_Popup("pop-spgcheck-edit");
        //setParentPopWin("pop-spgcheck-edit", null);
        setParentUpdateCount(updateCount + 1);
        CUTIL.jsopen_Popup(e);
        setErrorList([]);
    }
    const [selLang, setSelLang] = useState(CONST.STR_APILANG_KOR);
    const langSet = [
        { "tabId": 0, "tabTxt": "한국어", "tabVal": CONST.STR_APILANG_KOR },
        { "tabId": 1, "tabTxt": "English", "tabVal": CONST.STR_APILANG_ENG },
        { "tabId": 2, "tabTxt": "中文", "tabVal": CONST.STR_APILANG_CHA },
    ];
    useEffect(() => {
        //setSpgCheckItem(null);//null
        setSelLang(CONST.STR_APILANG_KOR);
    }, []);
    function onClickLangTab(e) {
        var actTag = (e.target.tagName === "LI") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        setSelLang(tabInfo.tabVal);
    }
    function setSpgCheckItemItemName(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "checkItemName": e.target.value }) : fcheck)));
    }
    function setSpgCheckItemDescription(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "description": e.target.value }) : fcheck)));
    }
    function setSpgCheckItemWeight(e) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang) ? Object.assign(Object.assign({}, fcheck), { "weight": e.target.value }) : fcheck)));
    }
    function setSpgcheckItemRefDtoList(e, ridx) {
        setSpgCheckItem(spgCheckItem.map((fcheck) => ((fcheck.language === selLang)
            ? Object.assign(Object.assign({}, fcheck), { "checkItemRefDtoList": fcheck.checkItemRefDtoList.map((ref, idx) => ((ridx === idx) ? Object.assign(Object.assign({}, ref), { "reference": e.target.value }) : ref)) }) : fcheck)));
    }
    function onClickDoUpdateSpgCheck(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            var isOk = confirm(`내용을 저장하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            setRecoilIsLoadingBox(true);
            spgCheckItem.map((fcheck, idx) => __awaiter(this, void 0, void 0, function* () {
                CUTIL.sleep(500);
                //clog("UPDATE SPG CHECK : " + idx + " : " + JSON.stringify(fcheck));
                doCnt++;
                data = yield HTTPUTIL.PromiseHttp({
                    "httpMethod": "PUT",
                    "appPath": `/api/v2/checksheet/step/spg/item`,
                    appQuery: {
                        "code": fcheck.code,
                        "language": fcheck.language,
                        "name": fcheck.checkItemName,
                        "description": fcheck.description,
                        "weight": fcheck.weight,
                        "checkItemRefDtoList": fcheck.checkItemRefDtoList,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    doneCnt++;
                    if (data.codeNum == CONST.API_200) {
                        succCnt++;
                    }
                    else {
                        data.body.errorList.map((elist) => (errList.push({ "field": elist.field + fcheck.language, "msg": elist.msg })));
                    }
                }
                if (doneCnt === 3) { // KOR/ENG/CHA
                    setErrorList(errList);
                    setParentListReload(true, -1); // only list reload & page reset done
                    setParentClistMode("READ");
                    setParentUpdateCount(updateCount + 1);
                    setParentPopWin("pop-spgcheck-detail", //pop-spgcheck-detail
                    React.createElement(PopupSpgCheckView, { htmlHeader: React.createElement("h1", null, "\uB2E4\uAD6D\uC5B4 \uAD00\uB9AC"), checkInfo: checkInfo, setListReload: props.setListReload, clistMode: "READ", setClistMode: props.setClistMode, setPopWin: props.setPopWin }));
                    if (doCnt === succCnt) {
                        CUTIL.jsclose_Popup("pop-spgcheck-edit");
                        var popupVal = e.target.getAttribute("data-pop");
                        if (CUTIL.isnull(popupVal))
                            e.target.setAttribute("data-pop", "pop-spgcheck-detail");
                        CUTIL.jsopen_Popup(e);
                    }
                    else {
                    }
                    doneCnt = 0;
                    setRecoilIsLoadingBox(false);
                }
            }));
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (React.createElement(React.Fragment, { key: `rfr_${idx.toString()}` },
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC810\uAC80\uB2E8\uACC4"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkStepDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAE30\uAE30 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.spgDto.name : "", disabled: true }))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uADF8\uB8F9 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", value: (checkItem.language === selLang) ? checkItem.checkGroupDto.groupName : "", disabled: true })))),
                React.createElement("ul", { className: "tab__small" }, langSet.map((tlang, idx) => (React.createElement("li", { key: `tli_${idx.toString()}`, className: (tlang.tabVal === selLang) ? "on" : "", onClick: (e) => onClickLangTab(e), "data-value": JSON.stringify(tlang) },
                    React.createElement("a", null, tlang.tabTxt))))),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "name" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.checkItemName)) ? checkItem.checkItemName : "" : "", onChange: (e) => setSpgCheckItemItemName(e), disabled: (selLang === CONST.STR_APILANG_KOR) ? true : false }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "name" + checkItem.language)).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC124\uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "description" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.description)) ? checkItem.description : "" : "", onChange: (e) => setSpgCheckItemDescription(e), disabled: (selLang === CONST.STR_APILANG_KOR) ? true : false }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "description" + checkItem.language)).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uAC00\uC911\uCE58"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", className: (errorList.filter(err => (err.field === "weight" + checkItem.language)).length > 0) ? "input-error" : "", value: (checkItem.language === selLang) ? (!CUTIL.isnull(checkItem.weight)) ? checkItem.weight : "" : "", onChange: (e) => setSpgCheckItemWeight(e), disabled: true }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "weight" + checkItem.language)).map((err) => err.msg)))))))),
            React.createElement("div", { className: "tbl-list" },
                React.createElement("table", { summary: "\uC810\uC218, \uD3C9\uAC00\uAE30\uC900 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD310\uC815 List \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uD310\uC815 List"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "16%" } }),
                        React.createElement("col", { style: { "width": "84%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col" }, "\uC810\uC218"),
                            React.createElement("th", { scope: "col" }, "\uD3C9\uAC00\uAE30\uC900"))),
                    React.createElement("tbody", null, (spgCheckItem) && spgCheckItem.filter(citem => citem.language === selLang).map((checkItem, idx) => (checkItem.checkItemRefDtoList.map((citem, ridx) => (React.createElement("tr", { key: `tr_${ridx.toString()}` },
                        React.createElement("td", null,
                            React.createElement("p", null, citem.score)),
                        React.createElement("td", null, (selLang === CONST.STR_APILANG_KOR)
                            ? React.createElement("p", { className: "txt-left" }, citem.reference)
                            : React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { value: citem.reference, onChange: (e) => setSpgcheckItemRefDtoList(e, ridx) })))))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "js-open", "data-pop": "pop-spgcheck-detail", onClick: (e) => onClickDoUpdateSpgCheck(e) },
                React.createElement("span", null, "\uC800\uC7A5")))));
}
// 버전 변경 팝업 
function PopupChangeSpgVersion(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const versionList = props.versionList;
    const nversion = props.versionInfo;
    const setParentSpgVersion = props.setSpgVersion;
    const setParentVersionReload = props.setVersionReload;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const adminType = props.adminType;
    function onClickCancel(e) {
        //setParentListReload(true, 0);
        CUTIL.jsclose_Popup("pop-version-ok");
    }
    function onClickDoChangeSpgVersion(e, nver) {
        return __awaiter(this, void 0, void 0, function* () {
            //return;
            //clog("doUpdateHttpMessage : " + JSON.stringify(cmsg));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/checksheet/spg/version?versionNo=${nver.versionNo}&spgName=${nver.spgName}`,
                appQuery: { /*
                  "versionNo": nver.versionNo,
                  "spgName": nver.spgName,
                */},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum === CONST.API_200) {
                    //setParentSpgVersion(nver);
                    //setParentVersionReload(true);
                    setParentSelTree(adminType, Object.assign(Object.assign({}, selTree), { "reload": true }));
                    CUTIL.sleep(500);
                    alert(JSON.stringify(data.body));
                }
                else {
                    alert(JSON.stringify(data.body.errorList));
                }
                CUTIL.jsclose_Popup("pop-version-ok");
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, "\uC120\uD0DD\uD55C \uBC84\uC804\uC73C\uB85C \uBCC0\uACBD\uD558\uC5EC \uC801\uC6A9\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"),
            React.createElement("ul", { className: "versioninfo" },
                React.createElement("li", null,
                    React.createElement("span", null, "\uAE30\uC874 \uBC84\uC804"),
                    versionList.filter((sver) => sver.enabled).map((sver, idx) => ((idx === 0) && React.createElement("strong", { key: `st_${idx.toString()}` },
                        sver.spgName,
                        " ",
                        sver.versionNo)))),
                React.createElement("li", null,
                    React.createElement("span", null, "\uC2E0\uADDC \uBC84\uC804"),
                    React.createElement("strong", null,
                        nversion.spgName,
                        " ",
                        nversion.versionNo)))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "btn-close", onClick: (e) => onClickDoChangeSpgVersion(e, nversion) },
                React.createElement("span", null, "\uD655\uC778")))));
}
